// Mirror of EuropassPdfDiplomasSection.jsx: bullet title, then per diploma an
// uppercase date line, an uppercase title + school line, and a grey rule.

import { formatDate } from "../../../../utils/formatDate";
import { bulletSectionTitle, run } from "../../shared/wordHelpers";
import { EUROPASS_TEXT, FONT_VERDANA } from "../../shared/wordTheme";
import { EU_INDENT, euPara, euRule } from "../euLayout";

export function buildEuropassDiplomas( { data, props, translations } ) {
    const { diplomas } = data;
    const { isAnonymous, documentLanguage } = props;
    const t = translations?.pdf ?? {};

    const elements = bulletSectionTitle( t.diplomasTitle, { font: FONT_VERDANA, indent: EU_INDENT } );

    diplomas
        .filter( diploma => diploma.from && ( diploma.to || diploma.isCurrent ) )
        .sort( ( a, b ) => a.order - b.order )
        .forEach( diploma => {
            const dateText = `${ formatDate( diploma.from, documentLanguage ) } - ${ diploma.isCurrent ? t.isCurrentLabel : formatDate( diploma.to, documentLanguage ) }`;
            elements.push( euPara( run( dateText, { pt: 8, allCaps: true, font: FONT_VERDANA } ) ) );
            elements.push( euPara( [
                run( `${ diploma.diplomaTitle ?? "" } `, { pt: 8, bold: true, allCaps: true, color: EUROPASS_TEXT, font: FONT_VERDANA } ),
                run( isAnonymous ? t.diplomasSchoolLabel : diploma.schoolName, { pt: 8, allCaps: true, color: EUROPASS_TEXT, font: FONT_VERDANA } ),
            ] ) );
            elements.push( euRule() );
        } );

    return elements;
}
